import { BrokerNerdsBarkerCoreEnumsMarketplace, BrokerNerdsBarkerCoreModelsMarketplacesEvent } from '../api';
import { TicketmasterMetadata } from '../types';

export function generateTicketEvolutionUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }
  return `https://core.ticketevolution.com/tickets/events/all/${eventId}/all`;
}

export function generateSeatGeekUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }

  return `https://seatgeek.com/e/events/${eventId}`;
}

export function generateTicketNetworkUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }

  return `https://www.ticketnetwork.com/tickets/${eventId}`;
}

export function generateStubHubUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }

  return `https://www.stubhub.com/event/${eventId}`;
}

export function generateVividSeatsUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }

  return `https://www.vividseats.com/x/production/${eventId}`;
}

export function generateTicketmasterUrl(eventId: string | null) {
  if (!eventId) {
    return '';
  }

  return `https://www.ticketmaster.com/event/${eventId}`;
}

export function parseVividSeatsUrl(url: string) {
  const regex = /vividseats\.com\/.*?production\/(\d{7})/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}

export function parseStubHubUrl(url: string) {
  const regex = /stubhub.*?event\/(\d{9}).*/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}

export function parseTicketEvolutionUrl(url: string) {
  const regex = /core\.ticketevolution\.com\/tickets\/events\/.*?\/(\d{7})\/all/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}

export function parseSeatGeekUrl(url: string) {
  const regex = /seatgeek\.com.*?(\d{7,8}).*/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}

export function parseTicketNetworkUrl(url: string) {
  const regex = /ticketnetwork\.com\/tickets\/(\d{7})/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[1];
  }

  return null;
}

export function parseTicketmasterUrl(url: string) {
  const regex = /(ticketmaster|livenation).*?\/event\/(\w{16})/;
  const match = url.match(regex);
  if (match && match.length > 1) {
    return match[2];
  }

  return null;
}

export const parseTicomboUrl = (url: string): string | null => {
  const regex = /ticombo\.com\/.*([0-9a-f]{8}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{4}-?[0-9a-f]{12})/i;

  const match = url.match(regex);
  return match ? match[1] : null;
};

export function parseEventIdFromUrl(url: string) {
  const ticketEvolutionId = parseTicketEvolutionUrl(url);
  if (ticketEvolutionId) {
    return ticketEvolutionId;
  }

  const ticketNetworkId = parseTicketNetworkUrl(url);
  if (ticketNetworkId) {
    return ticketNetworkId;
  }

  const ticketmasterId = parseTicketmasterUrl(url);
  if (ticketmasterId) {
    return ticketmasterId;
  }

  const ticomboId = parseTicomboUrl(url);
  if (ticomboId) {
    return ticomboId;
  }

  return parseSeatGeekUrl(url);
}

export function generateSkyBoxInvoiceUrl(invoiceId: string) {
  return `https://skybox.vividseats.com/invoices?invoiceId=${invoiceId}`;
}

export function generateMarketplaceEventUrl(marketplaceId: BrokerNerdsBarkerCoreEnumsMarketplace, marketplaceEventId: string) {
  switch (marketplaceId) {
    case BrokerNerdsBarkerCoreEnumsMarketplace.TicketEvolution:
      return generateTicketEvolutionUrl(marketplaceEventId);
    case BrokerNerdsBarkerCoreEnumsMarketplace.SeatGeek:
      return generateSeatGeekUrl(marketplaceEventId);
    case BrokerNerdsBarkerCoreEnumsMarketplace.TicketNetwork:
      return generateTicketNetworkUrl(marketplaceEventId);
    case BrokerNerdsBarkerCoreEnumsMarketplace.StubHub:
      return generateStubHubUrl(marketplaceEventId);
    case BrokerNerdsBarkerCoreEnumsMarketplace.VividSeats:
      return generateVividSeatsUrl(marketplaceEventId);
    case BrokerNerdsBarkerCoreEnumsMarketplace.Ticketmaster:
      return generateTicketmasterUrl(marketplaceEventId);
    default:
      return 'Unable to generate URL';
  }
}

export function getTicketMasterEventIdForUrls(event: BrokerNerdsBarkerCoreModelsMarketplacesEvent) {
  if (!event.metadata) { return ''; }
  const metadata = JSON.parse(event.metadata) as TicketmasterMetadata;
  return metadata.TicketmasterId;
}
